import React, { useEffect, useState } from 'react';
import authService from '../api-authorization/AuthorizeService';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ItemsList from '../ItemsList.js';
import { GanttList } from '../GanttList.js';
import Card from 'react-bootstrap/Card';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Tab from 'react-bootstrap/Tab';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';

export function Projects() {

    const d = new Date();
    const minYear = d.getFullYear();

    const [key, setKey] = useState("allProjects");
    const [years, setYears] = useState([]);
    const [columns2, setColumns2] = useState([
        { id: 'projectTitle', name: 'Project Title', sortable: true, filter: 'search', labelFormat: 'linkToItem', aggregate: false, minWidth: '120px' },
        { id: 'value', name: 'Value', sortable: true, filter: null, labelFormat: 'dollar', aggregate: true },
        { id: 'startYear', name: 'Fiscal Start Year', sortable: true, filter: null, labelFormat: 'textBox', aggregate: false, defaultFilter: '', min: minYear, max: minYear + 10, minWidth: '100px' },
        { id: 'quarter', name: 'Start Quarter', sortable: false, filter: null, labelFormat: 'select', aggregate: false, selections: ["Q1", "Q2", "Q3", "Q4"], minWidth: '100px' },
        { id: 'duration', name: 'Duration (months)', sortable: true, filter: null, labelFormat: 'textBox', aggregate: false, min: 1, max: 120, minWidth: '80px' },
    ]);
    const [secondaryItems, setSecondaryItems] = useState([
        { id: 'subtable1', duration: 'Funding' },
        { id: 'subtable2', duration: 'Total submitted projects' },
        { id: 'subtable3', duration: 'Over/under budget' },
        { id: 'subtable4', duration: 'Total on-hold projects' },
        { id: 'subtable5', duration: 'Total draft projects' }
    ]);


    useEffect(() => {
        loadSecondaryItems();
    }, []);

    async function loadSecondaryItems() {
        const token = await authService.getAccessToken();
        const response = await fetch("api/capitalplans", {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        });

        const items = await response.json();

        let minY = d.getFullYear();
        let maxY = d.getFullYear();

        items.forEach((item, index) => {
            if (index === 0) {
                minY = item.fiscalYear;
                maxY = item.fiscalYear;
            } else {
                maxY = item.fiscalYear;
            }
        });

        const newYears = [];
        for (let y = minY; y <= maxY; y++) newYears.push(y);

        const updatedColumns = [...columns2];
        const updatedSecondary = [...secondaryItems];

        newYears.forEach((year, index) => {
            updatedColumns.push({
                id: 'year' + index,
                name: year,
                sortable: false,
                filter: null,
                labelFormat: 'html',
                aggregate: false
            });

            updatedSecondary.forEach(s => {
                if (s.duration === 'Funding') {
                    s['year' + index] = items
                        .filter(i => i.fiscalYear === year)
                        .reduce((acc, cur) => acc + cur.investmentAmount, 0);
                } else {
                    s['year' + index] = 0;
                }
            });
        });

        setYears(newYears);
        setColumns2(updatedColumns);
        setSecondaryItems(updatedSecondary);
    }

    const defaultColumns = [
        { id: 'projectTitle', name: 'Project Title', sortable: true, filter: 'search', labelFormat: 'linkToItem' },
        { id: 'type', name: 'Type', sortable: true, filter: 'select', selectId: 'type' },
        { id: 'description', name: 'Description', sortable: true },
        { id: 'value', name: 'Value', sortable: true, labelFormat: 'dollar', aggregate: true },
        { id: 'startYear', name: 'Fiscal Start Year', sortable: true, filter: 'yearRange' },
        { id: 'duration', name: 'Duration (months)', sortable: true },
        { id: 'status', name: 'Status', sortable: true, filter: 'select', selectId: 'statusId' },
        { id: 'lastUpdated', name: 'Last Updated', sortable: true, labelFormat: 'date' }
    ];
    const [columns, setColumns] = useState(defaultColumns);
    const allColumns = defaultColumns;

    const mapFunction = q => ({
        id: q.id,
        projectTitle: q.projectTitle,
        type: q.type,
        typeID: q.type,
        description: q.description,
        value: q.value,
        startYear: q.startYear,
        duration: q.duration,
        status: q.status,
        statusId: q.statusID,
        lastUpdated: new Date(q.lastUpdated),
    });

    const mapFunction2 = q => {
        let durationQuarters = Math.ceil(q.duration / 3);
        let startQuarter = Number(q.quarter.replace("Q", ""));
        let remainingQuarters = durationQuarters;
        let quarterIndex = startQuarter - 1;

        const mapped = {
            id: q.id,
            projectTitle: q.projectTitle,
            type: q.type,
            description: q.description,
            value: q.value,
            startYear: q.startYear,
            quarter: q.quarter,
            duration: q.duration,
            status: q.status,
            statusId: q.statusID,
            lastUpdated: new Date(q.lastUpdated),
        };

        columns2.forEach(c => {
            if (c.id.startsWith("year")) {
                let year = Number(c.name);

                if (year >= q.startYear && remainingQuarters > 0) {
                    let blocks = "";

                    if (quarterIndex > 0)
                        blocks = "<i class='bi bi-square' style='color: lightgray;'></i>".repeat(quarterIndex);

                    while (quarterIndex < 4) {
                        blocks += remainingQuarters > 0
                            ? "<i class='bi bi-square-fill' style='color: #003DB8;'></i>"
                            : "<i class='bi bi-square' style='color: lightgray;'></i>";

                        remainingQuarters--;
                        quarterIndex++;
                    }

                    quarterIndex = 0;
                    mapped[c.id] = blocks;
                } else {
                    mapped[c.id] = "<i class='bi bi-square' style='color: lightgray;'></i>".repeat(4);
                }
            }
        });

        return mapped;
    };

    const handleOnSelect = key => setKey(key);

    const handleOnChange = (item, columnID, value) => {
        item[columnID] = value;

        let startQuarter = Number(item.quarter.replace("Q", ""));
        let remainingQuarters = Math.ceil(item.duration / 3);
        let quarterIndex = startQuarter - 1;

        columns2.forEach(c => {
            if (c.id.startsWith("year")) {
                let year = Number(c.name);

                if (year >= item.startYear && remainingQuarters > 0) {
                    let blocks = "";

                    if (quarterIndex > 0)
                        blocks = "<i class='bi bi-square' style='color: lightgray;'></i>".repeat(quarterIndex);

                    while (quarterIndex < 4) {
                        blocks += remainingQuarters > 0
                            ? "<i class='bi bi-square-fill' style='color: #003DB8;'></i>"
                            : "<i class='bi bi-square' style='color: lightgray;'></i>";

                        remainingQuarters--;
                        quarterIndex++;
                    }

                    quarterIndex = 0;
                    item[c.id] = blocks;
                } else {
                    item[c.id] = "<i class='bi bi-square' style='color: lightgray;'></i>".repeat(4);
                }
            }
        });
    };

    return (
        <div>
            <div className="card mb-2">
                <div className="card-body">
                    <span className="h5">Projects</span>
                </div>
            </div>

            <Card>
                <Tab.Container id="scenario-tabs" activeKey={key}>
                    <Card.Header>
                        <Stack direction="horizontal" gap={3}>
                            <ToggleButtonGroup name="projects" type="radio">
                                <ToggleButton
                                    id="tb1"
                                    variant={key === "allProjects" ? 'primary' : 'outline-primary'}
                                    value={1}
                                    onClick={() => handleOnSelect("allProjects")}
                                >
                                    All Projects
                                </ToggleButton>

                                <ToggleButton
                                    id="tb2"
                                    variant={key === "capitalPlan" ? 'primary' : 'outline-primary'}
                                    value={2}
                                    onClick={() => handleOnSelect("capitalPlan")}
                                >
                                    Capital Plan
                                </ToggleButton>
                            </ToggleButtonGroup>

                            <Button href="projects/add" variant="primary" className="ms-auto">
                                Add Project
                            </Button>
                        </Stack>
                    </Card.Header>

                    <Card.Body>
                        <Tab.Content>
                            <Tab.Pane eventKey="allProjects">
                                <ItemsList
                                    columns={columns}
                                    allColumns={allColumns}
                                    setColumns={setColumns}
                                    itemName="Project"
                                    addItemUrl="projects/add"
                                    mapFunction={mapFunction}
                                    getItemsUrl="api/projects"
                                    uniqueIdColumn="id"
                                    itemUrlBase="projects"
                                    shouldUpdate={true}
                                    showDownload={true}
                                    showHeader={true}
                                    hideAddItem={true}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="capitalPlan">
                                <GanttList
                                    columns={columns2}
                                    itemName="Project"
                                    addItemUrl="projects/add"
                                    mapFunction={mapFunction2}
                                    secondaryItems={secondaryItems}
                                    getItemsUrl="api/projects"
                                    uniqueIdColumn="id"
                                    showHeader={false}
                                    showFooter={false}
                                    itemUrlBase="projects"
                                    onChangeMethod={handleOnChange}
                                />
                            </Tab.Pane>
                        </Tab.Content>
                    </Card.Body>
                </Tab.Container>
            </Card>
        </div>
    );
}
